import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { NgStyle } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective } from '@ngx-translate/core';
import { ColorManagementService } from '@app/core/services/colors/color-management.service';
import { ColorGroup } from '@app/core/enums/color-group.enum';

@Component({
  selector: 'gc-ld-logger-noise-serving-cell-id',
  standalone: true,
  imports: [NgStyle, SvgIconComponent, TranslateDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-serving-cell-id.component.html',
  host: {
    class: 'flex items-center',
  },
})
export class LdLoggerNoiseServingCellIdComponent {
  private colorManagementService = inject(ColorManagementService);

  public servingCellId = input.required<string | undefined | null>();

  public color = computed(() => {
    const servingCellId = this.servingCellId();

    return servingCellId
      ? this.colorManagementService.getColorInstanceById(servingCellId, ColorGroup.Regular).toRgbString()
      : null;
  });
}
